import { jsx as i, Fragment as _, jsxs as z } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { S as f } from "./index-DoOsnuB6.js";
import { c as y } from "./index-BNmRGtA6.js";
import { c as d } from "./clsx-OuTLNxxd.js";
import { S as x } from "./Spinner-Drz3dWpe.js";
import './Button.css';const h = "_buttonBase_1w6qn_75", w = "_button_1w6qn_75", B = "_xxSmallSize_1w6qn_119", b = "_xSmallSize_1w6qn_127", q = "_smallSize_1w6qn_135", g = "_defaultSize_1w6qn_143", p = "_largeSize_1w6qn_149", v = "_iconSize_1w6qn_157", F = "_primary_1w6qn_166", N = "_secondary_1w6qn_175", W = "_tertiary_1w6qn_188", j = "_ghost_1w6qn_210", V = "_ghostBrand_1w6qn_211", k = "_outline_1w6qn_251", C = "_surface_1w6qn_264", R = "_isFullWidth_1w6qn_270", A = "_rounded_1w6qn_274", t = {
  buttonBase: h,
  button: w,
  xxSmallSize: B,
  xSmallSize: b,
  smallSize: q,
  defaultSize: g,
  largeSize: p,
  iconSize: v,
  primary: F,
  secondary: N,
  tertiary: W,
  ghost: j,
  ghostBrand: V,
  outline: k,
  surface: C,
  isFullWidth: R,
  rounded: A
}, D = y(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      outline: t.outline,
      surface: t.surface
    },
    size: {
      "xx-small": t.xxSmallSize,
      "x-small": t.xSmallSize,
      small: t.smallSize,
      default: t.defaultSize,
      large: t.largeSize,
      icon: t.iconSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), m = c(
  ({ asChild: l = !1, className: n, disabled: e, pressed: a, ...o }, s) => {
    const r = l ? f : "button", S = a === void 0 ? void 0 : { "aria-pressed": a, "data-state": a ? "on" : "off" };
    return /* @__PURE__ */ i(
      r,
      {
        className: d(t.buttonBase, n),
        "data-cxy-name": "button-base",
        disabled: e,
        ref: s,
        ...o,
        ...S
      }
    );
  }
), E = c(
  ({ asChild: l, isLoading: n, loadingText: e, variant: a, ...o }, s) => /* @__PURE__ */ i(_, { children: n ? /* @__PURE__ */ i(u, { ...o, "aria-busy": n, disabled: n, ref: s, variant: a, children: /* @__PURE__ */ z(_, { children: [
    e || "Loading",
    /* @__PURE__ */ i(x, { size: "s", variant: a === "secondary" ? "dark" : "light" })
  ] }) }) : /* @__PURE__ */ i(u, { ...o, asChild: l, ref: s, variant: a }) })
), u = c(
  ({ className: l, isFullWidth: n, rounded: e, size: a, variant: o, ...s }, r) => /* @__PURE__ */ i(
    m,
    {
      className: d(
        D({ variant: o, size: a }),
        { [t.isFullWidth]: n, [t.rounded]: e },
        l
      ),
      "data-cxy-name": "button",
      "data-testid": "button-component",
      ref: r,
      ...s
    }
  )
);
E.displayName = "Button";
m.displayName = "ButtonBase";
export {
  E as B,
  m as a,
  D as b
};
